import { Badge } from '@/types/badges';

interface BadgeIconProps {
  badge: Badge;
  size?: 'sm' | 'md' | 'lg';
  unlocked?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-lg',
  md: 'w-12 h-12 text-2xl',
  lg: 'w-16 h-16 text-4xl',
};

const rarityColors = {
  common: 'bg-gray-100 border-gray-300',
  rare: 'bg-blue-100 border-blue-400',
  epic: 'bg-purple-100 border-purple-400',
  legendary: 'bg-yellow-100 border-yellow-400',
};

export function BadgeIcon({ 
  badge, 
  size = 'md', 
  unlocked = true,
  className = '' 
}: BadgeIconProps) {
  return (
    <div 
      className={`
        ${sizeClasses[size]} 
        ${rarityColors[badge.rarity]}
        ${unlocked ? '' : 'opacity-30 grayscale'}
        flex items-center justify-center
        rounded-full border-2
        transition-all hover:scale-110
        ${className}
      `}
      title={badge.code}
    >
      {badge.iconEmoji || badge.iconUrl || '🏆'}
    </div>
  );
}
